import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Stack,
  useTheme,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useEffect, useState, useMemo, useRef, useCallback } from "react";

// Función para dividir las palabras en columnas

const WordHeader = ({ words, onWordClick, index }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))
  const [displayWords, setDisplayWords] = useState([])

  useEffect(()=> {

    let displayWordsTemp = [...words.slice(0, 6)];
    if (!displayWordsTemp.includes(words[index])) {
      displayWordsTemp.pop()
      displayWordsTemp.push(words[index])
    }
    setDisplayWords(displayWordsTemp.sort(() => Math.random() - 0.5))

  }, [words, index])


  return (
    <Box
      sx={{
        py: { xs: 1.5, sm: 2 },
        px: { xs: 1, sm: 2 },
        width: "100%",
        overflow: "hidden",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Box
        sx={{
          maxWidth: "lg",
          mx: "auto",
          width: "100%",
        }}
      >
        <Grid container spacing={2} justifyContent="center">
          {displayWords.map((word, index) => (
            <Grid
              item
              xs={4}
              sm={4}
              md={4}
              key={index}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="outlined"
                size={isSmallScreen ? "small" : "medium"}
                onClick={() =>  onWordClick(word)}
                sx={{
                  textTransform: "none",
                  fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                  width: "100%",
                  maxWidth: "150px",
                }}
              >
                {word}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default function DVEL_PAL({
  exercise,
  isRunning,
  velocity,
  onAnimationEnd,
  onAdditionalData
}) {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);
  const [shuffledWords, setShuffledWords] = useState<string[]>([]);
  const [allWords, setAllWords] = useState(
    exercise.content.split(",").reduce(function (a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []).sort(() => Math.random() - 0.5)
  );
  const randomIndex = useRef(0)
  const [gameState, setGameState] = useState({
    numAcertadas: 0,
    numErros: 0,
    velocity: velocity,
    velocitiesAverageArray: [velocity],
    velocityAverage: velocity
  });
  const words = useRef([])
  const totalPositions = 12; // 4 rows * 3 columns

  const shuffleWords = useCallback(() => {
    return randomArray(allWords, 12).sort(() => Math.random() - 0.5);
  }, [words.current]);

  const randomNumber = () => {
    const min = 2;
    const max = 11;
    return Math.round(Math.random() * (max - min) + min);
  }

  const initializeAnimation = useCallback(() => {
    setCurrentIndex(0);
    setIsAnimating(true);
    const wordsTemp = shuffleWords().sort(() => Math.random() - 0.5)
    words.current = [...wordsTemp]
    randomIndex.current = randomNumber()
    setShuffledWords(wordsTemp);
  }, [shuffleWords]);

  

  useEffect(() => {
    initializeAnimation();
  }, []);

  useEffect(() => {
    if (!isAnimating) return;
    const velocityFinal = ((1000 / velocity) * 60)
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        let nextIndex = prevIndex + 1;

        if (nextIndex > randomIndex.current) {
          setIsAnimating(false);
          if (onAnimationEnd) onAnimationEnd();
          return prevIndex;
        }
        return nextIndex;


      });
    }, velocityFinal);

    return () => clearInterval(timer);
  }, [velocity, isAnimating, onAnimationEnd, words.current.length]);

  const getWordAtPosition = (index: number) => {
    if (!isAnimating) return null;
    return index === currentIndex ? shuffledWords[currentIndex] : null;
  };

  const randomArray = (array, numSel) => {
    let myArray = [...array];

    let cuatroRandom = [];
    let posicionesElegidas = [];
    let i, j, r, c;
    for (i = 0; i < numSel; i++) {
      r =
        Math.floor(
          Math.random() * (myArray.length - posicionesElegidas.length)
        ) + 1;
      c = 0;
      j = 0;
      do if (posicionesElegidas.indexOf(j++) == -1) c++;
      while (c < r);
      j--;
      cuatroRandom.push(myArray[j]);
      posicionesElegidas.push(j);
    }
    return cuatroRandom;
    
  };

  const workClick = (word) => {
    if (!isAnimating) {
      const wordsFinal = [...words.current]
      let newErros = gameState.numErros;
      let numAcertadasNew = gameState.numAcertadas;
      let velocityNew = gameState.velocity
      let averageArray = gameState.velocitiesAverageArray
      if (shuffledWords.includes(word) && wordsFinal[randomIndex.current] == word) {
      //if (shuffledWords.includes(word) && shuffledWords[shuffledWords.length - 1] == word) {
          numAcertadasNew += 1;
          velocityNew += 20
      } else {
        newErros += 1;
        velocityNew -= 20
      }

      averageArray.push(velocityNew)

      const objectState = {
        numErros: newErros,
        numAcertadas: numAcertadasNew,
        velocity: velocityNew,
        velocityAverage: parseInt(averageArray.reduce((a, b) => a + b, 0) / averageArray.length),
        velocitiesAverageArray: averageArray
      }

      setGameState(objectState);
      onAdditionalData({
        numErros: newErros,
        numAcertadas: numAcertadasNew
      })
      initializeAnimation()
    }
  };

  useEffect(() => {}, [isRunning]);

  return (
    <div style={{width: "100%"}}>
      <Box
        sx={{
          position: 'relative',
          width: "70%",
          mx: "auto",
          p: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          background: "#ffffff",
          padding: '24px 12px',
        }}
      >
        <Grid container spacing={2} justifyContent="center">
          {Array(4)
            .fill(null)
            .map((_, rowIndex) =>
              Array(3)
                .fill(null)
                .map((_, colIndex) => {
                  const index = rowIndex * 3 + colIndex;
                  return (
                    <Grid
                      item
                      xs={4}
                      key={`${rowIndex}-${colIndex}`}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Paper
                        elevation={0}
                        sx={{
                          width: "100%",
                          maxWidth: 150,
                          height: 40,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: 0,
                          borderBottom: isAnimating
                            ? "2px solid black"
                            : "none",
                          backgroundColor: "transparent",
                          fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                          //transition:"color 0.3s ease-in-out, border-bottom 0.3s ease-in-out",
                          color: getWordAtPosition(index)
                            ? "black"
                            : "transparent",
                        }}
                      >
                        {getWordAtPosition(index) || ""}
                      </Paper>
                    </Grid>
                  );
                })
            )}
        </Grid>
      </Box>
      <Paper elevation={0} sx={{ p: 0.5, width: "100%" }}>
        <WordHeader
          words={words.current}
          onWordClick={workClick}
          index={randomIndex.current}
        />
      </Paper>

      <Paper elevation={2} sx={{ mt: 1, p: 1, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={5}>
            <TextField
              label="Velocidad de lectura"
              size="small"
              value={gameState.velocity}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={2}></Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="Velocidad promedio"
              value={gameState.velocityAverage}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              label="Palabras localizadas"
              size="small"
              value={gameState.numAcertadas}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12} sm={2}></Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              size="small"
              label="Errores"
              value={gameState.numErros}
              fullWidth
              InputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
